import {
  admin,
  palette,
  radii,
  shadow,
  typography,
} from '../../../../styles/tokens';
import type { CompetitorImportProfile } from './competitorImportProfiles';

interface ExportInstructionsOverlayProps {
  profile: CompetitorImportProfile;
  onContinue: () => void;
  onSkip: () => void;
}

// Shown once per Path 4 session after a competitor card is picked. Both
// buttons advance to the SpreadsheetPath shell; "I already have the file"
// just bypasses the step visually.
export default function ExportInstructionsOverlay({
  profile,
  onContinue,
  onSkip,
}: ExportInstructionsOverlayProps) {
  return (
    <div
      style={{
        padding: 24,
        background: palette.white,
        border: `1px solid ${palette.g150}`,
        borderRadius: radii.md,
        boxShadow: shadow.xs,
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: typography.size.heading,
          fontWeight: typography.weight.semibold,
          color: admin.header,
          marginBottom: 16,
        }}
      >
        {profile.exportInstructionsTitle}
      </h2>

      <ol
        style={{
          margin: 0,
          paddingLeft: 20,
          marginBottom: 20,
          color: admin.body,
          fontSize: typography.size.body,
          lineHeight: typography.lineHeight.relaxed,
        }}
      >
        {profile.exportInstructionsSteps.map((step, i) => (
          <li key={i} style={{ marginBottom: 6 }}>
            {step}
          </li>
        ))}
      </ol>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={onContinue}
          style={{
            padding: '10px 20px',
            background: palette.accent,
            color: palette.white,
            border: 'none',
            borderRadius: radii.sm,
            fontSize: typography.size.body,
            fontWeight: typography.weight.semibold,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          Upload your {profile.displayName} export
        </button>
        <button
          type="button"
          onClick={onSkip}
          style={{
            padding: '10px 20px',
            background: palette.white,
            color: admin.body,
            border: `1px solid ${palette.g200}`,
            borderRadius: radii.sm,
            fontSize: typography.size.body,
            fontWeight: typography.weight.semibold,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          I already have the file
        </button>
      </div>
    </div>
  );
}
